import React from "react";
import classNames from "classnames";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "../../Component";

function MessageBlocks({ message }) {
  if (message == null || message === "") return null;
  if (typeof message !== "string") {
    return <div className="text-soft">{message}</div>;
  }
  const parts = message
    .split(/\n\n/)
    .map((s) => s.trim())
    .filter(Boolean);
  if (parts.length === 0) return null;
  return (
    <div className="text-soft">
      {parts.map((p, i) => (
        <p key={i} className={i < parts.length - 1 ? "mb-2" : "mb-0"}>
          {p}
        </p>
      ))}
    </div>
  );
}

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  children,
  confirmText = "Confirm",
  cancelText = "Cancel",
  type = "danger",
  loading = false,
  backdrop = "static",
  modalClassName,
  contentClassName,
}) => {
  const confirmColor =
    type === "danger" ? "danger" : type === "warning" ? "warning" : type === "success" ? "success" : "primary";

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      backdrop={backdrop}
      zIndex={2000}
      modalClassName={classNames("admin-modal-gutter", modalClassName)}
      contentClassName={contentClassName}
    >
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>
        <MessageBlocks message={message} />
        {children}
      </ModalBody>
      <ModalFooter className="border-top-0 pt-0">
        <Button color="light" type="button" onClick={onClose} disabled={loading}>
          {cancelText}
        </Button>
        <Button color={confirmColor} type="button" onClick={onConfirm} disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
              Saving…
            </>
          ) : (
            confirmText
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
